export * from './datei-hochladen-post-request.interface';
export * from './datei-hochladen-post-response.interface';
export * from './datei-hochladen-post.shapes';
